import { Box } from "@mui/material";
import { useState } from "react";
import StepsItem from "./StepItem";
import Boxoutline from "../../../../../../media/images/icons/outline-box";
export interface IStepItem {
  index: number;
  title: string;
  status: "pending" | "inprogress" | "done" | "error";
  Icon: (color: string) => JSX.Element;
}
export default function StepItems() {
  const [stepItems] = useState<IStepItem[]>([
    {
      index: 1,
      title: "تایید شرکت <br/> حمل",
      status: "inprogress",
      Icon: (color) => <Boxoutline color={color} size={28} />,
    },
    {
      index: 2,
      title: "بارگیری <br/> از مبدا",
      status: "pending",
      Icon: (color) => <Boxoutline color={color} size={28} />,
    },
    {
      index: 3,
      title: "در مسیر <br/> مقصد",
      status: "pending",
      Icon: (color) => <Boxoutline color={color} size={28} />,
    },
    {
      index: 4,
      title: "تخلیه در <br/> مقصد",
      status: "pending",
      Icon: (color) => <Boxoutline color={color} size={28} />,
    },
  ]);
  return (
    <Box
      sx={{
        mt: 2,
        width: "100%",
        paddingX: "16px",
        margin: "auto",
        backgroundColor: "bgColor.white",
        display: "flex",
        gap: "3px",
      }}
    >
      {stepItems.map((item) => (
        <StepsItem {...item} />
      ))}
    </Box>
  );
}
